import { Switch, Route } from 'react-router-dom';
import DefaultLayout from './pages/layouts/Default';
import LoginLayout from './pages/layouts/Login';

import Login                from './pages/Login';
import Facilities           from './pages/Facilities';
import User                 from './pages/user/User';
import Role                 from './pages/user/Role';
import Profile              from './pages/user/Profile';

import QoCPeriodComparison   from './pages/qoc/QoCPeriodComparison';
import QoCStandardSetup      from './pages/qoc/QoCStandardSetup';
import QoCAssessment         from './pages/qoc/QoCAssessment';
import QoCAssessmentImport   from './pages/qoc/QoCAssessmentImport';
import QoCCAP                from './pages/qoc/QoCCAP';
import QoCTeamRegistry       from './pages/qoc/QoCTeamRegistry';
import QoCFacilityProfile    from './pages/qoc/QoCFacilityProfile';
import QoCDashboard          from './pages/qoc/QoCDashboard';
import QoCCompliance         from './pages/qoc/QoCCompliance';
import QoCExecutiveDashboard from './pages/qoc/QoCExecutiveDashboard';
import QoCFacilityReport     from './pages/qoc/QoCFacilityReport';
import DashboardBuilder      from './pages/qoc/DashboardBuilder';
import QoCSchedules          from './pages/qoc/QoCSchedules';
import QoCApproval           from './pages/qoc/QoCApproval';
import QoCPeriods            from './pages/qoc/QoCPeriods';
import QoCKPIs               from './pages/qoc/QoCKPIs';
import QoCCustomerSurveys    from './pages/qoc/QoCCustomerSurveys';
import QoCQualityIndex       from './pages/qoc/QoCQualityIndex';
import QoCUserManual         from './pages/qoc/QoCUserManual';
import QoCHIESync            from './pages/qoc/QoCHIESync';
import QoCFacilityCoordinates from './pages/qoc/QoCFacilityCoordinates';
import QoCAccessControl      from './pages/qoc/QoCAccessControl';
import QoCPublicSurvey       from './pages/qoc/QoCPublicSurvey';
import UserActivityReport from './pages/qoc/UserActivityReport';
import QoCAwards from './pages/qoc/QoCAwards';

export default function Routes() {
    return (
        <Switch>
            {/* Public survey — no login required */}
            <Route exact path="/qoc/survey"         component={QoCPublicSurvey} />
            <Route exact path="/qoc/survey/select"  component={QoCPublicSurvey} />
            <Route exact path="/qoc/survey/:type"   component={QoCPublicSurvey} />

            {/* Auth */}
            <LoginLayout path="/" exact component={Login} />

            {/* Admin */}
            <DefaultLayout path="/profile"    component={Profile} />
            <DefaultLayout path="/users"      component={User} />
            <DefaultLayout path="/roles"      component={Role} />
            <DefaultLayout path="/facilities" component={Facilities} />

            {/* QoC */}
            <DefaultLayout path="/qoc/standards"           component={QoCStandardSetup} />
            <DefaultLayout path="/qoc/assessments"         component={QoCAssessment} />
            <DefaultLayout path="/qoc/assessment-import"   component={QoCAssessmentImport} />
            <DefaultLayout path="/qoc/approval"            component={QoCApproval} />
            <DefaultLayout path="/qoc/cap"                 component={QoCCAP} />
            <DefaultLayout path="/qoc/team-registry"       component={QoCTeamRegistry} />
            <DefaultLayout path="/qoc/facility-profile"    component={QoCFacilityProfile} />
            <DefaultLayout path="/qoc/analytics"           component={QoCDashboard} />
            <DefaultLayout path="/qoc/compliance"          component={QoCCompliance} />
            <DefaultLayout path="/qoc/kpis"                component={QoCKPIs} />
            <DefaultLayout path="/qoc/surveys"             component={QoCCustomerSurveys} />
            <DefaultLayout path="/qoc/quality-index"       component={QoCQualityIndex} />
            <DefaultLayout path="/qoc/executive-dashboard" component={QoCExecutiveDashboard} />
            <DefaultLayout path="/qoc/facility-report"     component={QoCFacilityReport} />
            <DefaultLayout path="/qoc/custom-dashboard"    component={DashboardBuilder} />
            <DefaultLayout path="/qoc/period-comparison"   component={QoCPeriodComparison} />
            <DefaultLayout path="/qoc/periods"             component={QoCPeriods} />
            <DefaultLayout path="/qoc/schedules"           component={QoCSchedules} />
            <DefaultLayout path="/qoc/access-control"      component={QoCAccessControl} />
            <DefaultLayout path="/qoc/hie-sync"            component={QoCHIESync} />
            <DefaultLayout path="/qoc/user-manual"         component={QoCUserManual} />
            <DefaultLayout path="/qoc/facility-coordinates"         component={QoCFacilityCoordinates} />
              <DefaultLayout path="/qoc/activity-trail"         component={UserActivityReport} />
            <DefaultLayout path="/qoc/awards"                component={QoCAwards} />
            {/* Fallback */}
            <LoginLayout component={Login} />
        </Switch>
    );
}